/**
 * @packageDocumentation
 * @module HackerAPI.Pipeline
 */
import { __extends } from "tslib";
import HackerAPIFetch from "../hackerapi-fetch/hackerapi-fetch";
import Stage from "./stage/stage";
import Field from "./field/field";
import Base from "../base/base";
import { parseDate } from "../utils/utils";
/**
 * A data container for a pipeline stage with static methods for interfacing with hackerapi
 * @class
 * @extends { HackerAPI.Base }
 */
var Pipeline = /** @class */ (function (_super) {
    __extends(Pipeline, _super);
    function Pipeline(_a) {
        var id = _a.id, slug = _a.slug, name = _a.name, event_slug = _a.event_slug, eventSlug = _a.eventSlug, description = _a.description, max_num_claims = _a.max_num_claims, maxNumClaims = _a.maxNumClaims, max_num_collaborators = _a.max_num_collaborators, maxNumCollaborators = _a.maxNumCollaborators, relationships = _a.relationships, start_time = _a.start_time, startTime = _a.startTime, end_time = _a.end_time, endTime = _a.endTime, stage_order = _a.stage_order, stageOrder = _a.stageOrder, permissions = _a.permissions, claims = _a.claims, stages = _a.stages, fields = _a.fields;
        var _this = _super.call(this, {
            startTime: Base.dateTimeHandler,
            endTime: Base.dateTimeHandler,
            claims: Base.doNotSendHandler
        }) || this;
        /**
         * The ID of the pipeline
         * @type { number }
         */
        _this.id = id;
        /**
         * The slug of the pipeline
         * @type { string }
         */
        _this.slug = slug;
        /**
         * The name of the pipeline
         * @type { string }
         */
        _this.name = name;
        /**
         * The slug of the event that this pipeline is for
         * @type { string }
         */
        _this.eventSlug = event_slug || eventSlug;
        /**
         * The description of the pipeline
         * @type { string }
         */
        _this.description = description;
        /**
         * The maximum number of claims that this pipeline can have
         * @type { number }
         */
        _this.maxNumClaims = max_num_claims || maxNumClaims;
        /**
         * The maximum number of collaborators that can collaborate on this pipeline
         * @type { number }
         */
        _this.maxNumCollaborators = max_num_collaborators || maxNumCollaborators;
        /**
         * The relations in the database that this pipeline has.
         * @todo Currently not being sent to server because it seems to cause 500s and I'm not sure what it does
         * @type { string[] }
         */
        _this.relationships = relationships || [];
        /**
         * The start time of the pipeline
         * @type { Date }
         */
        _this.startTime = parseDate(start_time || startTime);
        /**
         * The end time of the pipeline
         * @type { Date }
         */
        _this.endTime = parseDate(end_time || endTime);
        /**
         * The order of the stages
         * @todo Actually find out what this does
         * @type { number[] }
         */
        _this.stageOrder = stage_order || stageOrder || [];
        /**
         * The permissions that this pipeline has
         * @type { string[] }
         */
        _this.permissions = permissions || [];
        /**
         * The number of claims that there are for this pipeline
         * @type { number }
         */
        _this.claims = claims;
        /**
         * The stages that a claim can be in a pipeline
         * @type { HackerAPI.Pipeline.Stage[] }
         */
        _this.stages = (stages || []).map(function (s) { return new Stage(s); });
        /**
         * The fields for this pipeline
         * @type { HackerAPI.Pipeline.Field[] }
         */
        _this.fields = (fields || []).map(function (f) { return new Field(f); });
        return _this;
    }
    Object.defineProperty(Pipeline, "Stage", {
        /**
         * @returns
         */
        get: function () {
            return Stage;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Pipeline, "Field", {
        /**
         * @returns
         */
        get: function () {
            return Field;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Fetches a pipeline from hackerapi.com
     * @param pipeline
     * @param pipeline.id
     * @param token
     * @returns
     */
    Pipeline.fetch = function (_a, token) {
        var id = _a.id;
        return HackerAPIFetch({
            path: "/v2/pipelines/" + id,
            method: "GET",
            token: token
        }).then(function (data) { return new Pipeline(data); });
    };
    /**
     * Creates a new pipeline on hackerapi
     * @param pipeline
     * @param token
     * @returns
     */
    Pipeline.create = function (pipeline, token) {
        return HackerAPIFetch({
            path: "/v2/pipelines",
            method: "POST",
            token: token,
            body: pipeline.toHackerAPIFormat()
        }).then(function (data) { return new Pipeline(data); });
    };
    /**
     * Updates a pipeline on hackerapi
     * @param pipeline
     * @param token
     * @returns
     */
    Pipeline.update = function (pipeline, token) {
        return HackerAPIFetch({
            path: "/v2/pipelines/" + pipeline.id,
            method: "PUT",
            token: token,
            body: pipeline.toHackerAPIFormat()
        }).then(function (data) { return new Pipeline(data); });
    };
    /**
     * Deletes a pipeline on hackerapi. Note that a pipeline cannot be deleted if it still has claims attached to it.
     * @param pipeline
     * @param pipeline.id
     * @param token
     * @returns
     */
    Pipeline.delete = function (_a, token) {
        var id = _a.id;
        return HackerAPIFetch({
            path: "/v2/pipelines/" + id,
            method: "DELETE",
            token: token
        });
    };
    return Pipeline;
}(Base));
export default Pipeline;
//# sourceMappingURL=pipeline.js.map